export const MAX_GLB_SIZE_BYTES = 100 * 1024 * 1024;

export const SUPPORTED_REQUIRED_GLB_EXTENSIONS = new Set<string>([
  'KHR_draco_mesh_compression',
]);
export const SUPPORTED_USED_GLB_EXTENSIONS = new Set<string>([
  'KHR_draco_mesh_compression',
]);
export const REJECTED_GLB_EXTENSIONS = new Set<string>([
  'EXT_meshopt_compression',
  'KHR_texture_basisu',
  'KHR_materials_unlit',
  'KHR_materials_clearcoat',
  'KHR_materials_specular',
  'KHR_materials_transmission',
  'KHR_materials_volume',
  'KHR_materials_iridescence',
  'KHR_materials_sheen',
  'KHR_materials_emissive_strength',
]);
export const ALLOWED_RUNTIME_MATERIAL_CLASSES = new Set<string>(['MeshStandardMaterial']);

export const SUPPORTED_IMAGE_MIME_TYPES = new Set<string>([
  'image/png',
  'image/jpeg',
]);
